import {AppointmentBooked} from 'domain/usecases';
import {DateFormatEnum} from 'presentation/constants';
import {formatAddress, formatDateString} from 'presentation/utils';
import normalizeDate from 'presentation/utils/normalizeDate/normalizeDate';
import {validatePhoneNumbers} from '../validatePhoneNumbers';
import {ParsedHealthAppointment} from './types';

export const parseHealthAppointments = (
	agendamentosSaude: AppointmentBooked[],
): ParsedHealthAppointment[] =>
	agendamentosSaude.map(item => {
		const normalizedDate = normalizeDate(item.dtConsulta);

		return {
			bookingNumber: item.nuConsulta?.toString(),
			specialtyCode: item.cdEspecialidade?.toString(),
			subSpecialtyCode: item.cdSubEspecialidade?.toString(),
			specialtyName: item.dsSubEspecialidade
				? `${item.dsEspecialidade} - ${item.dsSubEspecialidade}`
				: item.dsEspecialidade,
			clinicName: item.nmPrestadorJuridico,
			providerName: item.nmPrestadorFisico,
			bookingType: item.tipoConsulta,
			formattedAddress: formatAddress({
				type: item.tipoLogradouro,
				state: item.cdUf,
				city: item.nmCidade,
				number: item.numero?.toString(),
				address: item.logradouro,
				complement: item.complemento,
				district: item.bairro,
				reference: item.pontoReferencia,
			}),
			date: formatDateString(normalizedDate, DateFormatEnum.DATE_FORMAT_1, 'P HH:mm'),
			dateOnly: formatDateString(
				normalizedDate,
				DateFormatEnum.DATE_FORMAT_1,
				DateFormatEnum.DATE_FORMAT_8,
			),
			hour: formatDateString(normalizedDate, DateFormatEnum.DATE_FORMAT_1, 'HH:mm'),
			formattedDateWithWeekday: formatDateString(
				normalizedDate,
				DateFormatEnum.DATE_FORMAT_1,
				'EEEE, dd/MM/yy',
			),
			telehealthUrl: item.urlconsulta,
			protocolNumber: item.nuProtocolo,
			isConfirmed: item.confirmado === 'Sim',
			phoneNumbers: validatePhoneNumbers(item.nuTelefone),
			email: item.email,
			phone: item.telefone,
			isFavorite: item.flPrestadorFavorito === 'S',
			cdPrestador: item.cdPrestadorFisico,
			flExecutaSessao: item.flExecutaSessao,
		};
	});
